export const MAX_PEEK_ROUNDS = 7;
export const SLATE_DARK_SHELL =
  'border-[rgba(255,255,255,0.09)] bg-[radial-gradient(circle_at_92%_-30%,rgba(36,197,106,0.22),transparent_58%),linear-gradient(160deg,#22232C,#0C0C12)] shadow-[0_14px_28px_-16px_rgba(0,0,0,0.7)]';
export const URGENT_COUNTDOWN_CHIP =
  'border-[rgba(240,179,74,0.42)] bg-[rgba(240,179,74,0.18)] text-[#F0B34A]';
